import TileComponent from "./TileComponent";

export default TileComponent;
